import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import preloaderComponentStyle
    from "../../assets/jss/material-kit-pro-react/components/preloaderComponentStyle";

const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

function PreloaderComponent(props) {
    const { classes } = props;
    return (
        <div
            className={
                classes.wrapper
            }
        >
            <CircularProgress className={classes.progress} color="primary" />
        </div>
    );
}

PreloaderComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(preloaderComponentStyle)(PreloaderComponent);